import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {Subject} from 'rxjs';
import {PersonaGiuridicaDTO} from '../../models/persona-giuridica-dto';
import {PersonaGiuridica} from '../../models/portale/persona-giuridica-model';
import {ComponentOutputStatus} from '../../normalizzazione/component-output-status';
import {DelegheService} from '../../services/deleghe-services/deleghe.service';

@Component({
	selector: 'lib-ricerca-pg',
	templateUrl: './ricerca-pg.component.html',
	styleUrls: ['./ricerca-pg.component.css']
})
export class RicercaPgComponent implements OnInit {

	@Input()
	namespace: string;

	@Input()
	readOnly: boolean;

	@Input()
	showRagioneSociale: boolean = true;

	@Input()
	showPartitaIVA: boolean = true;

	// @Output()
	// personaGiuridicaSelezionata: EventEmitter<PersonaGiuridica> = new EventEmitter<PersonaGiuridica>();

	@Output()
	done: EventEmitter<
		ComponentOutputStatus<PersonaGiuridica>
	> = new EventEmitter<ComponentOutputStatus<PersonaGiuridica>>();

	resetForm = new Subject<boolean>();

	codiceFiscale: string = "";
	ragioneSociale: string = "";
	partitaIVA: string = "";

	dataSource: MatTableDataSource<any>;
	listaPg;
	offset: number = 0;
	pageNumber: number = 0;
	pageSize: number = 5;
	paged: boolean = true;
	showNoResults: boolean;
	viewIntPg: boolean = false;
	viewResultTable: boolean = false;
	resLenPg = 0;
	validationFormPG: boolean = false;

	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

	pageEvent: PageEvent;

	displayedColumns: string[] = [
		'ragioneSociale',
		'pIva',
		'codFiscale',
		'seleziona'
	];

	constructor(
		private delegheService: DelegheService,
	) { }

	ngOnInit(): void {
	}

	personaGiuridicaReady(pgStatus: ComponentOutputStatus<PersonaGiuridicaDTO>) {
		// console.log("[personaGiuridicaReady]", pgStatus);
		this.validationFormPG = pgStatus.status;

		if (pgStatus.output.codiceFiscale != undefined) {
			this.codiceFiscale = pgStatus?.output.codiceFiscale.toUpperCase().trim();
		}
		if (pgStatus.output?.ragioneSociale != undefined) {
			this.ragioneSociale = pgStatus?.output.ragioneSociale.toUpperCase().trim();
		}
		if (pgStatus.output?.partitaIVA != undefined) {
			this.partitaIVA = pgStatus?.output.partitaIVA.toUpperCase().trim();
		}

		//TODO
		// this.changesPersonaGiuridica$.next(
		// 	pgStatus.mapValue(pg => (rap: LegaleRappresentanteDTO) => rap.datiSocieta = pg)
		// );
	}

	getListaPg() {
		this.listaPg = '';
		this.dataSource = new MatTableDataSource(this.listaPg);

		const pg = new PersonaGiuridicaDTO();
		pg.codiceFiscale = this.codiceFiscale;
		pg.ragioneSociale = this.ragioneSociale;
		pg.partitaIVA = this.partitaIVA;

		if (pg.codiceFiscale != "" && pg.partitaIVA == "" && pg.ragioneSociale == "") {
			console.log("[Ricerca Anagrafe Tributaria]");
			this.delegheService.getPersonaGiuridicaCodiceFiscale(pg.codiceFiscale).pipe(
				// pluck("datiPersonaGiuridica")
			)
				.subscribe(
					(res: PersonaGiuridica) => {
						console.log('[pg]', res);
						this.listaPg = res;
						// console.log('[listaPg]', this.listaPg);
						if (this.listaPg) {
							this.showNoResults = false;
							this.viewIntPg = true;
							this.viewResultTable = true;
							// this.dataSource = new MatTableDataSource(this.listaPg['content']);
							this.dataSource = new MatTableDataSource([this.listaPg]);
							// this.dataSource = new MatTableDataSource([res]);
							// this.dataSource.paginator = this.paginator;
							// this.resLenPg = res['content'].length;
							this.resLenPg = 1;
						} else {
							this.showNoResults = true;
							this.viewIntPg = false;
							this.viewResultTable = false;
							this.resLenPg = 0;
						}
					},
					err => {
						// console.log('[errore - getListaPfPaged]', err);
						this.showNoResults = true;
						this.viewIntPg = false;
						this.viewResultTable = false;
						this.resLenPg = 0;
					}
				)
		} else {
			console.log("[Ricerca Sul Portale]");
			this.delegheService.getListaPgPaged(this.pageSize, this.pageNumber, pg).subscribe(
				(res: PersonaGiuridica) => {
					console.log('[pg]', res);
					this.listaPg = res;
					// console.log('[listaPg]', this.listaPg);
					if (this.listaPg) {
						this.showNoResults = false;
						this.viewIntPg = true;
						this.viewResultTable = true;
						this.dataSource = new MatTableDataSource(this.listaPg['content']);
						this.dataSource.paginator = this.paginator;
						this.resLenPg = res['content'].length;
					} else {
						this.showNoResults = true;
						this.viewIntPg = false;
						this.viewResultTable = false;
						this.resLenPg = 0;
					}
				},
				err => {
					// console.log('[errore - getListaPfPaged]', err);
					this.showNoResults = true;
					this.viewIntPg = false;
					this.viewResultTable = false;
					this.resLenPg = 0;
				}
			)
		}
	}

	pulisciForm() {
		this.resetForm.next(true);
		this.viewResultTable = false;
		this.dataSource = new MatTableDataSource(null);
		this.viewIntPg = false;
		// console.log('[pulisciForm - resetForm]', this.resetForm);
	}

	areSearchParameterValid(): boolean {
		return (
			this.validationFormPG &&
			(this.codiceFiscale != "" ||
				this.ragioneSociale != "" ||
				this.partitaIVA != "")
		);
	}

	personaGiuridicaSelected(row: PersonaGiuridica) {
		// console.log('[PersonaGiuridica]', row);
		this.done.emit(ComponentOutputStatus.of(true, row));
	}
}
